import {
    createUnknownComponentVNode as _$cc,
    createElementVNode as _$ce,
    noop as _$no,
    className as _$cn,
    map as _$ma,
} from 'intact';
import {getClassAndStyleForFixed} from './useFixedColumns';
import {Dropdown, DropdownMenu, DropdownItem} from '../dropdown';
import {Button} from '../button';
import {Icon} from '../icon';
import {Checkbox} from '../checkbox';
import {makeGroupMenuStyles} from './styles';
import {isStringOrNumber, get} from 'intact-shared';
import {context as GroupContext} from './useGroup';
import {context as SortableContext} from './useSortable';
import {linkEvent} from 'intact';
import {context as TableContext} from './useColumns';
import {context as ResizableContext} from './useResizable';
import {context as FixedColumnsContext} from './useFixedColumns';
import {stopPropagation} from '../utils';

var _$tmp0 = {
    'className': 'ion-android-arrow-dropdown'
};
var _$tmp1 = {
    'className': 'ion-android-arrow-dropup k-asc'
};
var _$tmp2 = {
    'className': 'ion-android-arrow-dropdown k-desc'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    var _$blocks = {};
    var __$blocks = {};
    
    const {title, fixed, group, multiple, key, sortable, cols, rows} = this.get();
    const {onSelect, isChecked, getGroupText} = this.group;
    
    return _$cc(TableContext.Consumer, {
        'children': checkType => {
            return _$cc(GroupContext.Consumer, {
                'children': ({group: currentGroup, onChange}) => {
                    return _$cc(SortableContext.Consumer, {
                        'children': ({sort, onChange: onChangeSort}) => {
                            return _$cc(ResizableContext.Consumer, {
                                'children': ({resizable, onStart}) => {
                                    return _$cc(FixedColumnsContext.Consumer, {
                                        'children': (offsetMap) => {
                                            const {className, style} = getClassAndStyleForFixed(this.get(), offsetMap[key], checkType);
                                            const classNameObj = {
                                                'k-column-sortable': sortable,
                                                [className]: className,
                                            }
                                        
                                            const groupValue = currentGroup && currentGroup[key];
                                            const groupText = getGroupText(groupValue);
                                        
                                            const type = sort && sort.key === key && sort.type;
                                        
                                            let checked;
                                            return _$ce(2, 'th', [
                                                (resizable && this.$vNode.props.prevVNode) ?
                                                    _$ce(2, 'div', null, 1, 'k-table-resize', {
                                                        'ev-mousedown': e => {
                                                            e._vNode = this.$vNode;
                                                            onStart(e);
                                                        }
                                                    }) :
                                                    undefined,
                                                _$ce(2, 'div', [
                                                    _$ce(2, 'div', [
                                                        (
                                                            (_$blocks['title'] = function($super) {
                                                                return title;
                                                            }),
                                                            (__$blocks['title'] = function($super, data) {
                                                                var block = $blocks['title'];
                                                                var callBlock = function() {
                                                                    return _$blocks['title'].call($this, $super, data);
                                                                };
                                                                return block ?
                                                                    block.call($this, callBlock, data) :
                                                                    callBlock();
                                                            }),
                                                            __$blocks['title'](_$no)
                                                        ),
                                                        groupText
                                                    ], 0, 'k-table-title-text c-ellipsis'),
                                                    (group) ?
                                                        _$cc(Dropdown, {
                                                            'position': {my: 'center top', at: 'center bottom+5', collision: 'flipfit'},
                                                            'key': 'dropdown',
                                                            'children': [
                                                                _$cc(Button, {
                                                                    'icon': true,
                                                                    'size': 'mini',
                                                                    'className': 'k-table-group',
                                                                    'ev-click': stopPropagation,
                                                                    'children': (
                                                                        _$cc(Icon, _$tmp0)
                                                                    )
                                                                }),
                                                                _$cc(DropdownMenu, {
                                                                    'className': _$cn({"k-table-group-dropdown": true, [makeGroupMenuStyles()]: true}),
                                                                    'children': (
                                                                        _$ma(group, function($value, $key) {
                                                                            return _$cc(DropdownItem, {
                                                                                'ev-select': () => onSelect($value.value, groupValue, onChange),
                                                                                'hideOnSelect': !multiple,
                                                                                'className': _$cn({'k-active': (checked = isChecked($value.value, groupValue))}),
                                                                                'children': (
                                                                                    (multiple) ?
                                                                                        _$cc(Checkbox, {
                                                                                            'value': checked,
                                                                                            'children': $value.label
                                                                                        }) :
                                                                                        _$ce(2, 'span', $value.label, 0)
                                                                                )
                                                                            });
                                                                        }, $this)
                                                                    )
                                                                })
                                                            ]
                                                        }, 'dropdown') :
                                                        undefined,
                                                    (sortable) ?
                                                        _$ce(2, 'div', [
                                                            _$cc(Icon, _$tmp1),
                                                            _$cc(Icon, _$tmp2)
                                                        ], 4, _$cn({'k-column-sort': true, [`k-${type}`]: type})) :
                                                        undefined
                                                ], 0, 'k-table-title')
                                            ], 0, _$cn(classNameObj), {
                                                'style': style,
                                                'title': isStringOrNumber(title) ? title + (groupText || '') : null,
                                                'ev-click': sortable ? linkEvent(key, onChangeSort) : null,
                                                'colspan': cols,
                                                'rowspan': rows
                                            }, null, this.elementRef)
                                        }
                                    })
                                }
                            })
                        }
                    })
                }
            })
        }
    });
};